import React from 'react'
import swal from "sweetalert";
import DroughtDownloadModal from './DroughtDownloadModal'

import { DateInput } from "semantic-ui-calendar-react";
import moment from 'moment'
import { Icon, Menu, Popup, Message, Button } from "semantic-ui-react";
import { MDBBtn } from 'mdbreact'
import colors from '../colors'
import { Segment, Sidebar, Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { DateRange } from 'react-date-range';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import calendar from "./calendar.ico";
export default class DroughtTable extends React.Component {
  constructor(props) {
    super(props)
    console.log(props.date)
    this.state = {
      modal: false,
      date: null,
      activeIndex: 0,
      // selectionRange:
      // {

      //     startDate: new Date(props.etstart_date),
      //     endDate: new Date(props.etend_date),
      //   key: 'selection'

      // },

    }
  }



  handleDownload = async () => {
    this.props.handleSubmitDisable()
    this.setState({
      modal: true
    })
   
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }
  render() {
let enabledDates_hd;

    if (this.props.hdavailableDates!==null){
     enabledDates_hd = this.props.hdavailableDates.map((momentDate) => momentDate.toDate());
    }
    console.log("ads  hd",this.props.hdavailableDates)
    let droughtproducts, monthOptions, sriproducts

    if (this.props.droughtproducts !== null) {
      droughtproducts = this.props.droughtproducts.map((product) => {
        return (<option value={product}>{product}</option>)
      })

    }
    if (this.props.monthly && this.props.hdavailableDates !== null) {
      monthOptions = this.props.hdavailableDates.map((date, key) => {

        return (
          <option value={moment(date, "MMMYYYY").format("MMMM YYYY")}>{moment(date, "MMMYYYY").format("MMMM YYYY")}   </option>
        )
      })
    }
    console.log(this.props.sriproducts)
    if (this.props.sriproducts) {
      sriproducts = this.props.sriproducts.map((e, key) => {
        var patt = new RegExp("^[0-9]*");
        var res = patt.exec(e);
        console.log(res)
        if (res[0] !== "") {

          return (
            <option value={res} key={key}>{e}</option>
          )
        }
        else {
          return (
            <option value="cum" key={key}>{e}</option>
          )
        }
      })
    }
    console.log(this.props.hdsub)
    return (
      <div>
        {this.state.modal ? <DroughtDownloadModal modal={this.state.modal} title="Hydrological Drought Indices" toggle={this.toggle} theme="Drought"
          product={this.props.hdproductselected} hdsub={this.props.hdsub}
          d1={moment(this.props.hddate, "DD-MM-YYYY").format("YYYYMMDD")}
          user={window.sessionStorage.getItem("loginUser")}
        /> : null}


        <div className="wrapper_data">
          <div id="one">

            Select Product
                    <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleDroughtChange}
              value={this.props.hdproductselected}
              selected={this.props.hdproductselected}
            >
              <option value="#">Select</option>
              {droughtproducts}

            </select>
            {this.props.hdproductselected === 'Standardized Runoff Index' ? <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleHDSubProduct}
              value={this.props.hdsub}
              selected={this.props.hdsub}
            >
              <option value="#">Select</option>
              {sriproducts}
            </select> : null
            }
          </div>
          <div id="two">
            Availability {this.props.hdstart_date !== null ?
              <p style={{ color: "blue" }}> {moment(this.props.hdstart_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} - {moment(this.props.hdend_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} </p> : null}

          </div>
        </div>



        <div className="wrapper_data">

          {this.props.hdavailableDates !== null && !this.props.monthly && this.props.hdsub !== '#' ?
            <div id="one">
              Select Date
              {/* <DateInput
                // inline
                name="hddate"
                inline
                value={moment(this.props.hddate, "DD-MM-YYYY").format(
                  "DD-MM-YYYY"
                )}
                onChange={this.props.handleHDDateChange}
                dateFormat="DD-MM-YYYY"
                markColor="orange"
                placeholder="Date"
                iconPosition="left"
                closable={false}
                initialDate={this.props.hddate}
                maxDate={this.props.hdstartdate}
                minDate={this.props.hdenddate}

                // value={this.state.date}
                closeOnMouseLeave
                enable={this.props.hdavailableDates}
                marked={this.props.hdavailableDates}
                startMode="day"
                pickerWidth="200px"
                popupPosition="top right"
                clearIcon={<Icon name="remove" color="red" />}
              /> */}

              <DatePicker
                    closeOnScroll={true}

                    // inline
                    name="date"
                    inline={true}

                    value={moment(this.props.date, "DD-MM-YYYY").format(
                      "DD-MM-YYYY"
                    )}
                    onChange={(date) => this.props.handleHDDateChange(null, { name: 'hddate', value: moment(date).format('DD-MM-YYYY') })}
                    dateFormat="DD-MM-YYYY"
                    highlightDatesStyles="orange"
                    placeholder="Date"
                    iconPosition="left"
                    highlightDates={enabledDates_hd.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                    filterDate={(date) => enabledDates_hd.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                    dayClassName={(date) => {
                      const isEnabled = enabledDates_hd.some(
                        (enabledDate) => enabledDate.toDateString() === date.toDateString()
                      );
                      return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                    }}
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50} // Show 50 years in the dropdown

                    closable
                    //initialDate={this.props.date}
                    ///enable={this.props.availableDates}
                    //marked={this.props.availableDates}
                    //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                    //includeDates={this.props.availableDates.map((date) =>
                    //   moment(date, "DD-MM-YYYY").toDate()
                    // )}
                    startMode="day"
                    pickerWidth="200px"

                    popupPosition="top right"
                    clearIcon={<Icon name="remove" color="red" />}
                    minDate={new Date(Math.min(...enabledDates_hd.map((d) => d.getTime())))} // Set the minimum date
                    maxDate={new Date(Math.max(...enabledDates_hd.map((d) => d.getTime())))} // Set the maximum date

                    /> 
                                </div> : null}
          {this.props.hdavailableDates !== null && this.props.monthly ?
            <div id="one">
              Select Month
              <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                onChange={this.props.handleMonthChange}
              >
                <option value="#">Select</option>
                {monthOptions}
              </select></div>
            : null}







          <div id="two">

            {this.props.hddate !== null && this.props.download_enable ? <Message size='small'> 
            
              {this.props.monthly?<p>Selected Month:&nbsp; {moment(this.props.hddate, "DD-MM-YYYY").format(
                  "MMM-YYYY")}</p>:<p>Selected Date:&nbsp;{
                moment(this.props.hddate, "DD-MM-YYYY").format(
                  "DD-MMM-YYYY")} </p>} </Message> : null}
            {!this.props.submitdisable ?
              <button
                onClick={this.handleDownload}
                className="btn btn-primary text-capitalize"

              >
                Submit
            </button>
              : null}



          </div>


        </div>

        {/* <Button animated>
          <Link to="/webgis-drought/map">   <Button.Content visible>Geoportal</Button.Content>
            <Button.Content hidden>
              <Icon name='arrow right' />
            </Button.Content>
          </Link>
        </Button> */}


      </div>






    )
  }
}


